import type { Resource } from '../../';
export const search_box_frame_searchAll: Resource = {"default":"Search all \"{term}\""};
